module.exports = __webpack_public_path__ + "static/fonts/BMJUA_ttf.ttf?7dbe95a7";